export enum QuestionType {
  GUIDING = 'guiding',
  ASSESSMENT = 'assessment',
}

export interface Question {
  id: string;
  questionType: QuestionType;
  questionText: string;
  readingTip: string;
  correctAnswerExplanation: string;
  relatedPassageStartIndex: number | undefined;
  relatedPassageEndIndex: number | undefined;
  questionOptions: string[];
  questionOptionExplanations: string[];
  correctOptionIndex: number;
  order: number;
}
